import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {InicioFaces} from '../interfaces/inicioFaces';
import {thFaces} from '../interfaces/thFaces';
import { FormControl, FormGroup } from '@angular/forms';
import {HttpParams} from  "@angular/common/http";
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";

@Injectable({
  providedIn: 'root'
})
export class GestionthService {
public httpOptions = {
headers: new HttpHeaders({
'Access-Control-Allow-Origin': '*'
})

};

API_ENDPOINT: string =Constants.BASEURLAPI  + '/api';

  constructor(private httpClient: HttpClient) { }


public crearColaborador(insert : any) {
console.log('ingresasss',insert);
const  params = new  HttpParams().set('docid', insert.docid).set('cedula', insert.cedula).set('expide', insert.expide).set('nombre', insert.nombre).set('cargoid', insert.cargoid).set('sedeid', insert.sedeid).set('email', insert.email).set('fingreso', insert.fingreso).set('contratoid', insert.contratoid).set('salario', insert.salario).set('user', insert.user).set('pass', insert.pass).set('lugarExpide', insert.lugarExpide);
return this.httpClient.get(this.API_ENDPOINT + '/crearColaborador',{params});
} 

public crearSede(insertS : any) {
console.log('ingresasss',insertS);
const  params = new  HttpParams().set('sedeid', insertS.sedeid).set('ciudad', insertS.ciudad);
return this.httpClient.get(this.API_ENDPOINT + '/crearSede',{params});
} 
public ingresaCargo(ingresaC : any) {
console.log('ingresasss',ingresaC);
const  params = new  HttpParams().set('nombreC', ingresaC.ncargo);
return this.httpClient.get(this.API_ENDPOINT + '/ingresaCargo',{params});
} 

public listipodoc() {
return this.httpClient.get(this.API_ENDPOINT + '/listipodoc', this.httpOptions);
}

public liscargo() {
return this.httpClient.get(this.API_ENDPOINT + '/liscargo', this.httpOptions);
}

public liscontrato() {
return this.httpClient.get(this.API_ENDPOINT + '/liscontrato', this.httpOptions);
}
public lisede() {
return this.httpClient.get(this.API_ENDPOINT + '/lisede', this.httpOptions);
}

public cargaColaborador() {
return this.httpClient.get(this.API_ENDPOINT + '/cargaColaborador', this.httpOptions);
}

buscaColaborador(buscador : any){
  console.log("buicashash", buscador);
const  params = new  HttpParams().set('nombre', buscador.nombre);
return this.httpClient.get(this.API_ENDPOINT + '/buscaColaborador',{params});

}

buscaCargo(listC : any){
const  params = new  HttpParams().set('nameCargo', listC.nameCargo);
return this.httpClient.get(this.API_ENDPOINT + '/buscaCargo',{params});

}

buscarSede(listS : any){
console.log('servicio',listS);
const  params = new  HttpParams().set('nombreS', listS.nombreS);
return this.httpClient.get(this.API_ENDPOINT + '/buscarSede',{params});
}

buscaCertificado(listCertificado : any){
console.log('servicio',listCertificado);
const  params = new  HttpParams().set('colaborador', listCertificado.colaborador);
return this.httpClient.get(this.API_ENDPOINT + '/buscaCertificado',{params});
}


buscaDesprendibles(listDesprendible : any){
console.log('desprendible',listDesprendible);
const  params = new  HttpParams().set('persona', listDesprendible.persona);
return this.httpClient.get(this.API_ENDPOINT + '/buscaDesprendibles',{params});
}

public updateAll(insert : any) {
const  params = new  HttpParams().set('docid', insert.docid).set('cedula', insert.cedula).set('expide', insert.expide).set('nombre', insert.nombre).set('cargoid', insert.cargoid).set('sedeid', insert.sedeid).set('email', insert.email).set('fingreso', insert.fingreso).set('contratoid', insert.contratoid).set('salario', insert.salario).set('user', insert.user).set('pass', insert.pass).set('lugarExpide', insert.lugarExpide);
return this.httpClient.get(this.API_ENDPOINT + '/updateAll',{params});
} 



eliminarColaborador(documento_id: any){
console.log('eliminandooooo',documento_id);
const  params = new  HttpParams().set('documento_id', documento_id)
return this.httpClient.get(this.API_ENDPOINT + '/eliminarColaborador',{params});

}

eliminarSede(id: any){
console.log('eliminandooooo sede',id);
const  params = new  HttpParams().set('id', id)
return this.httpClient.get(this.API_ENDPOINT + '/eliminarSede',{params});

}

eliminarCertificado(id: any){
console.log('eliminandooooo CERTIFICADOOO',id);
const  params = new  HttpParams().set('id', id)
return this.httpClient.get(this.API_ENDPOINT + '/eliminarCertificado',{params});

}

eliminarDesprendible(id: any){
console.log('eliminandooooo DESPRENDIBLEE',id);
const  params = new  HttpParams().set('id', id)
return this.httpClient.get(this.API_ENDPOINT + '/eliminarDesprendible',{params});

}


eliminarCargo(id: any){
console.log('eliminandooooo cargooo',id);
const  params = new  HttpParams().set('id', id)
return this.httpClient.get(this.API_ENDPOINT + '/eliminarCargo',{params});

}


 insertCertificado(formData : FormData, certificado : any){

     return this.httpClient.post<any>(this.API_ENDPOINT+'/upload2/',formData,{reportProgress : true,
                  observe : 'events'});
    }


 insertDesprendibles(formData1 : FormData, desprendible : any){

     return this.httpClient.post<any>(this.API_ENDPOINT+'/upload3/',formData1,{reportProgress : true,
                  observe : 'events'});
    }


 uploadFile(formData) {
 
       let urlApi = this.API_ENDPOINT + '/subir';
       return this.httpClient.post<any>(urlApi, {params :formData});
    }



}
